<template>
  <div id="postAd">
    <img :src="isamnet" style="width: 100%" />
    <div class="postAd-wrapper" id="postAd-wrapper">
      <div v-if="creative.vast_xml" class="" id="postAd-video"></div>
      <div v-else-if="creative.image_url" class="postAd-wrapper-img">
        <a :href="creative.landing_page" target="_blank">
          <img
            id="postAd-img"
            :src="creative.image_url"
            width="100%"
            style="max-height: 400px"
          />
        </a>
      </div>
      <div class="postAd-wrapper-container">
        <div class="name" id="postAd-name" @click="openLandingPage()">
          <div class="icon" :style="backgroundImgStyle"></div>
          <div class="ml-12">
            {{ creative.advertiser_name }}
          </div>
        </div>
        <div
          id="postAd-content"
          class="content"
          :style="{ height: contentHeight + 'px' }"
        >
          <div
            id="postAd-content-inner"
            v-html="parseContentWithLineBreak"
            @click="openLandingPage()"
          ></div>
        </div>
        <div
          v-if="haveShowMore"
          class="show-more"
          id="postAd-showMore"
          @click="isExpand ? showLess() : showMore()"
        >
          {{ isExpand ? "....Show Less" : "....Show More" }}
        </div>
      </div>
    </div>
    <img
      src="https://cdn.aralego.net/rich_media/assets/parallaxScrolling/bg2.png"
      style="width: 100%"
    />
  </div>
</template>
<script>
import mixPreview from "@/components/mixins/preview.js";
import mixOutstream from "@/components/mixins/outstream.js";
import mixMobile from "@/components/mixins/mobile.js";
export default {
  data() {
    return {
      contentHeight: 0,
      contentInitHeight: 0,
      isExpand: false,
      haveShowMore: true,
    };
  },
  computed: {
    isamnet() {
      let domain = window.location.hostname;
      let isAmnet = "https://cdn.aralego.net/rich_media/assets";
      if (domain === "prism.amnet.tw") {
        isAmnet += "/amnet/bg.png";
      } else {
        isAmnet += "/parallaxScrolling/bg1.png";
      }
      return isAmnet;
    },
    backgroundImgStyle() {
      return {
        backgroundImage: `url("${this.creative.advertiser_icon}")`,
      };
    },
    parseContentWithLineBreak() {
      let a = this.creative.content;
      return a.replaceAll("\\n", "<br>");
    },
  },
  methods: {
    openLandingPage() {
      window.open(this.creative.landing_page, "_black");
      window.focus();
    },
    showMore() {
      let content = document.getElementById("postAd-content");
      let wrapper = document.getElementById("postAd-wrapper");
      wrapper.style.height = "auto";
      content.style.overflow = "auto";
      content.style.height = "auto";
      this.isExpand = true;
    },
    showLess() {
      let content = document.getElementById("postAd-content");
      let wrapper = document.getElementById("postAd-wrapper");
      wrapper.style.height = "480px";
      content.style.overflow = "hidden";
      content.style.height = this.contentInitHeight + "px";
      this.isExpand = false;
    },
    setContentHeight(idOfArr) {
      let wrapper = document.getElementById("postAd-wrapper");
      let totalHeightOfArr = 0;
      idOfArr.forEach((ele) => {
        totalHeightOfArr =
          totalHeightOfArr + document.getElementById(ele).clientHeight;
      });
      let name = document.getElementById("postAd-name");
      let showMore = document.getElementById("postAd-showMore");
      let wrapperHeight = wrapper.clientHeight;
      let nameHeight = name.clientHeight;
      let showMoreHeight = showMore.clientHeight;
      return (
        wrapperHeight - totalHeightOfArr - nameHeight - showMoreHeight - 24
      );
    },
    setHaveShowMore() {
      let inner = document.getElementById("postAd-content-inner");
      let innerHeight = inner.clientHeight;
      return innerHeight > this.contentInitHeight;
    },
    messageHandler(e) {
      const frame = document.querySelector(".ucfad");

      switch (e.data.type) {
        case "close":
          frame.style.display = "none";
          break;
        case "ready":
          this.setPlayerConfig();
          this.initialAd(this.creative.vast_xml);
          this.videoIO.observe(this.video_div);
          break;
        case "Loaded":
          frame.style.display = "block";
          this.onVideoPlay();
          this.removeVideoClickDiv();
          break;
        case "Start":
          // ad is start
          if (!this.isVideoViewable) this.onVideoPause();
          this.showToolBar();
          break;
        case "error":
          this.$notify.error({
            title: "Error",
            message: e.data.error,
            position: "bottom-right",
            offset: 20,
          });
        default:
          break;
      }
    },
  },
  mixins: [mixPreview, mixMobile, mixOutstream],
  mounted() {
    const vm = this;
    this.viewport();

    if (this.creative.image_url) {
      let imgEle = document.getElementById("postAd-img");
      imgEle.onload = function() {
        vm.contentHeight = vm.setContentHeight(["postAd-img"]);
        vm.contentInitHeight = vm.contentHeight;
        vm.haveShowMore = vm.setHaveShowMore();
      };
    } else if (this.creative.vast_xml) {
      this.creative.vast_xml = this.removeTrackingEvent(this.creative.vast_xml);
      const target = document.getElementById("postAd-video");
      this.addPlayer(target, target.clientWidth, 300);
      this.setStyle(this.video_div, this.position);
      vm.contentHeight = vm.setContentHeight(["postAd-video"]);
      vm.contentInitHeight = vm.contentHeight;
      vm.haveShowMore = vm.setHaveShowMore();
    }
  },
};
</script>
<style lang="sass" scoped>
.postAd-wrapper
  width: 100%
  height: 480px
  &-container
    padding: 8px 16px
    .name
      display: flex
      align-items: center
      &:nth-child(2)
        margin-left: 12px
    .content
      padding: 4px
      font-size: 14px
      overflow: hidden
      text-overflow: ellipsis
    .show-more
      height: 20px
      color: blue
      cursor: pointer
      padding: 4px
.icon
  width: 30px
  height: 30px
  background-repeat: no-repeat
  border-radius: 50%
  background-size: cover
  border: 1px solid AliceBlue
.ml
  &-12
    margin-left: 8px
#postAd-content-inner
  word-break: break-all
  word-wrap: break-word
</style>
